/**
 * 금액을 한글 표기로 변환 (영수증·견적서용, '일'을 생략하지 않는 표기)
 * 1000000 → "일백만", 1234567 → "일백이십삼만사천오백육십칠"
 */
export function koreanAmount(value) {
  let n = Math.floor(Number(String(value ?? '').replace(/,/g, '')) || 0)
  if (n <= 0) return ''
  const digits = '영일이삼사오육칠팔구'
  const small = ['', '십', '백', '천']
  const big = ['', '만', '억', '조']
  let result = ''
  let groupIdx = 0
  while (n > 0) {
    const group = n % 10000
    if (group > 0) {
      let part = ''
      let g = group
      for (let i = 0; g > 0; i++) {
        const d = g % 10
        if (d > 0) part = digits[d] + small[i] + part
        g = Math.floor(g / 10)
      }
      result = part + big[groupIdx] + result
    }
    n = Math.floor(n / 10000)
    groupIdx++
  }
  return result
}
